import * as angular from 'angular';

import { IdentityEasy } from './identity-easy.component';
import { IdentityEasyService } from './identity-easy.service';

angular
  .module('identity-easy', [])
  .component('identityEasy', IdentityEasy)
  .service('IdentityEasyService', IdentityEasyService);
